import React from 'react';
import propTypes from 'prop-types';
import './line_tabs.scss';

import { Tabs as BootstrapTabs, Tab as BootstrapTab } from 'react-bootstrap-for-bs3';

const LineTabs = (props) => {
  return (
    <BootstrapTabs
      transition={false}
      className='line-tabs-component margin-bottom-large'
      {...props}
    >
      {props.children}
    </BootstrapTabs>
  );
};

const LineTab = (props) => (
  <BootstrapTab className='line-tab-component' {...props}>
    {props.children}
  </BootstrapTab>
);

LineTabs.propTypes = {
  children: propTypes.node,
  activeKey: propTypes.string,
  onSelect: propTypes.func,
  id: propTypes.string,
  defaultActiveKey: propTypes.string,
};

LineTab.propTypes = {
  children: propTypes.node,
  eventKey: propTypes.string,
  title: propTypes.string,
  disabled: propTypes.bool,
};

export { LineTabs, LineTab };
